<template>
  <div class="form-group form-group--read-only">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <div class="lead">
          <span class="prefix" v-if="component.prefix">{{ component.prefix }}</span>
          <span class="text">{{ getValue() }}</span>
          <span class="suffix" v-if="component.suffix">{{ component.suffix }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Mask
import masker from '@/directives/mask/masker'
import tokens from '@/directives/mask/tokens'

export default {
  props: ['component', 'components', 'value'],
  name: 'TextReadOnly',
  methods: {
    getValue: function () {
      return masker(this.value, this.component.inputMask, true, tokens) || '-'
    }
  }
}
</script>
